// src/pages/Home.jsx
import React from "react";
import Hero from "../components/Hero";
import ServicesCard from "../components/ServiceCard";
import Innovation from "../assets/mx2_scanner.png";
import Team from "../assets/Team.jpeg";
import Sustain from "../assets/Inhouse1.png";
import Integrity from "../assets/Integrity1.jpg";
import Excellence from "../assets/Integrity1.jpeg";
import Commitment from "../assets/Commitment.jpg";

import Client1 from "../Clients/Godrej.png";
import Client2 from "../Clients/AlKhaja.jpeg";
import Client3 from "../Clients/Atissco.png";
import Client4 from "../Clients/Patel.jpg";
import Client5 from "../Clients/InSteel.jpg";
import Client6 from "../Clients/Inside.jpg";
import Client7 from "../Clients/HmmInfra.jpg";
import Client8 from "../Clients/Nuberg.jpg";
import Client9 from "../Clients/mahindraSanyo.gif";
import Client10 from "../Clients/Kazen.jpg";
import Client11 from "../Clients/AnupEngg.png";
import Client12 from "../Clients/Mazagon.jpg";

import capture3 from "../assets/machine.png";
import { Link } from "react-router-dom";
import { Activity, Zap, Circle, Droplet, CheckCircle } from "lucide-react";
import { Helmet } from "react-helmet-async";

const Home = () => {
  const values = [
    {
      title: "Innovation",
      desc: "Using Olympus OmniScan MX2 with custom PAUT/TOFD scanners, we implement cutting-edge technology to detect flaws, improve safety, and optimize inspection processes in pipelines and engineering fabrications.",
      img: Innovation, // Innovation / Tech
    },
    {
      title: "Teamwork",
      desc: "Our highly skilled team collaborates seamlessly, combining knowledge and experience to deliver precise and reliable NDT services, ensuring every project meets the highest quality standards.",
      img: Team, // Team collaboration
    },
    {
      title: "Sustainability",
      desc: "Self-designed scanners and in-house equipment ensure long-term operational efficiency, reducing downtime and minimizing environmental impact while maintaining superior inspection quality.",
      img: Sustain, // Sustainability / green
    },
    {
      title: "Integrity",
      desc: "We uphold the highest standards of professionalism and ethics in every inspection. Our team ensures that all testing procedures are performed accurately, transparently, and reliably. By adhering to strict industry standards and regulatory compliance, we provide clients with results they can trust. Every assessment is carried out with precision, accountability, and a commitment to safety, ensuring that operational decisions are based on sound, verified data. Our dedication to integrity guarantees consistent excellence, mitigates risk, and fosters long-term partnerships built on confidence and reliability.",
      img: Integrity, // Integrity / professionalism
    },
    {
      title: "Excellence",
      desc: "Providing independent NDT services worldwide, we uphold the highest standards of quality, precision, and safety. Our team combines decades of expertise with advanced technologies to deliver reliable inspection results across diverse industries. From complex industrial assets to critical infrastructure, we ensure compliance with international standards, empowering clients with actionable insights. Our unwavering focus on excellence drives continuous improvement, professional training, and innovation in every project. By prioritizing transparency, accuracy, and customer trust, we aim not only to meet expectations but to consistently exceed them — building long-term partnerships and global industry recognition.",
      img: Excellence, // Excellence / quality
    },
    {
      title: "Commitment",
      desc: "Our team is always available to support clients, offering timely responses, emergency inspections, and continuous monitoring to maintain the integrity of critical assets.",
      img: Commitment, // Commitment / service
    },
  ];

  const services = [
    {
      title: "Ultrasonic Testing (UT)",
      icon: <Activity size={28} />,
      desc: "High-precision ultrasonic inspections for pipelines and structures.",
      to: "/services#ut",
    },
    {
      title: "Phased Array Ultrasonic Testing (PAUT)",
      icon: <Zap size={28} />,
      desc: "Advanced PAUT inspections for welds and complex components.",
      to: "/services#paut",
    },
    {
      title: "Time of Flight Diffraction (TOFD)",
      icon: <Circle size={28} />,
      desc: "Accurate defect detection and sizing using TOFD technology.",
      to: "/services#tofd",
    },
    {
      title: "Magnetic Particle Testing (MPT)",
      icon: <Droplet size={28} />,
      desc: "Surface and near-surface flaw detection using MPT.",
      to: "/services#mpt",
    },
    {
      title: "Liquid Penetrant Testing (PT)",
      icon: <CheckCircle size={28} />,
      desc: "Ensuring surface integrity with reliable PT inspections.",
      to: "/services#pt",
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Focus Inspection Technology | Advanced NDT Inspection Services | PAUT
          TOFD UT RT MT PT
        </title>

        <meta
          name="description"
          content="
Focus Inspection Technology is a Non Destructive Testing company providing PAUT, TOFD, UT, RT, MT, PT, welding inspection, pipeline inspection, refinery inspection and industrial testing worldwide. Focus Inspection Technology is also known as Focus Inspection or Focus NDT.
"
        />

        <meta
          name="keywords"
          content="
Focus Inspection Technology,
Focus Inspection,
Focus NDT,
NDT company,
PAUT,
TOFD,
UT testing,
RT testing,
industrial inspection,
pipeline inspection,
shipyard inspection,
refinery inspection,
ndt india
"
        />

        <link rel="canonical" href="https://focusinspectiontechnology.com/" />

        {/* Open Graph */}

        <meta
          property="og:title"
          content="Focus Inspection Technology | NDT Inspection Company"
        />

        <meta
          property="og:description"
          content="Advanced NDT inspection services including PAUT TOFD UT RT MT PT worldwide."
        />

        <meta
          property="og:image"
          content="https://focusinspectiontechnology.com/images/innovation.png"
        />

        <meta
          property="og:url"
          content="https://focusinspectiontechnology.com/"
        />

        <meta property="og:type" content="website" />

        {/* Twitter */}

        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:title" content="Focus Inspection Technology" />

        <meta
          name="twitter:description"
          content="Professional NDT inspection company providing PAUT TOFD UT RT MT PT worldwide."
        />

        <meta
          name="twitter:image"
          content="https://focusinspectiontechnology.com/images/innovation.png"
        />
      </Helmet>

      <div>
        <Hero />

        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h2 className="text-3xl font-extrabold text-gray-900 mb-12 text-center">
            Our Company & Values
          </h2>

          <p className="text-gray-700 text-lg leading-relaxed text-center max-w-3xl mx-auto mb-12">
            FOCUS Inspection Technology specializes in PAUT, TOFD, UT, and MT
            inspections for Offshore and Onshore Pipelines and Engineering
            Fabrications. Our experienced and qualified team ensures highest
            standards of quality, safety, and integrity.
          </p>

          <div className="space-y-16">
            {values.map((val, idx) => (
              <div
                key={idx}
                className={`flex flex-col lg:flex-row items-center gap-8 ${
                  idx % 2 !== 0 ? "lg:flex-row-reverse" : ""
                }`}
              >
                {/* Image */}
                <div className="lg:w-1/2 flex justify-center">
                  <img
                    src={val.img}
                    alt={val.desc}
                    loading="lazy"
                    className="h-70 w-70 rounded-2xl shadow-lg object-cover"
                  />
                </div>

                {/* Text */}
                <div className="lg:w-1/2 space-y-4 text-center lg:text-left">
                  <h4 className="text-2xl font-bold text-blue-700">
                    {val.title}
                  </h4>
                  <p className="text-gray-600 text-lg leading-relaxed">
                    {val.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-gray-50 py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-extrabold text-gray-900 mb-12 text-center">
              Our Services
            </h2>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service, idx) => (
                <Link
                  key={idx}
                  to={service.to}
                  className="group flex flex-col items-center p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-shadow duration-300 text-center"
                >
                  <div className="p-4 rounded-full bg-blue-100 mb-4 text-blue-700">
                    {service.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2 group-hover:text-blue-700 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-sm">{service.desc}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* What We Do Section */}
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-extrabold text-gray-900 mb-6">
              What We Do
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto mb-12">
              At FOCUS Inspection Technology, we ensure precise inspections,
              accurate reporting, and compliance with international NDT
              standards. Our team specializes in advanced techniques for
              pipelines, engineering fabrications, and structural components.
            </p>

            <div className="grid sm:grid-cols-1 lg:grid-cols-3 gap-8 mt-8">
              <div className="p-6 bg-gray-50 rounded-2xl shadow hover:shadow-lg transition">
                <h3 className="text-xl font-semibold text-blue-700 mb-2">
                  High-Precision Inspections
                </h3>
                <p className="text-gray-600 text-sm">
                  Using cutting-edge NDT methods to detect defects and ensure
                  structural integrity.
                </p>
              </div>
              <div className="p-6 bg-gray-50 rounded-2xl shadow hover:shadow-lg transition">
                <h3 className="text-xl font-semibold text-blue-700 mb-2">
                  Certified Expertise
                </h3>
                <p className="text-gray-600 text-sm">
                  Our ASNT Level II/III certified team delivers accurate and
                  reliable testing services.
                </p>
              </div>
              <div className="p-6 bg-gray-50 rounded-2xl shadow hover:shadow-lg transition">
                <h3 className="text-xl font-semibold text-blue-700 mb-2">
                  Reliable Reporting
                </h3>
                <p className="text-gray-600 text-sm">
                  Comprehensive reports, audits, and recommendations for your
                  engineering projects.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Our Clients Section */}
        <section className="bg-gray-50 py-20 overflow-hidden">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Section Title */}
            <h2 className="text-3xl font-extrabold text-gray-900 mb-4 text-center">
              Trusted By Industry Leaders
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto mb-12 text-center">
              We are proud to collaborate with established companies worldwide.
            </p>

            {/* Auto-scrolling client logos */}
            <div className="overflow-hidden">
              {/* 🎯 Using a custom Tailwind value for gap to match the CSS exactly */}
              <div className="flex gap-[3rem] animate-scroll">
                {/* FIRST SET (11 clients) */}
                {[
                  Client1,
                  Client12,
                  Client2,
                  Client3,
                  Client4,
                  Client5,
                  Client6,
                  Client7,
                  Client8,
                  Client9,
                  Client10,
                  Client11,
                ].map((img, idx) => (
                  <img
                    key={idx}
                    src={img}
                    loading="lazy"
                    alt={`Client ${idx + 1}`}
                    className="w-[200px] h-[120px] object-contain flex-shrink-0"
                  />
                ))}

                {/* SECOND SET (11 duplicate clients for seamless loop) */}
                {[
                  Client1,
                  Client12,
                  Client2,
                  Client3,
                  Client4,
                  Client5,
                  Client6,
                  Client7,
                  Client8,
                  Client9,
                  Client10,
                  Client11,
                ].map((img, idx) => (
                  <img
                    key={`dup-${idx}`}
                    src={img}
                    loading="lazy"
                    alt={`Client ${idx + 1}`}
                    className="w-[200px] h-[120px] object-contain flex-shrink-0"
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Keyframe animation for scrolling */}
          <style jsx>{`
            .animate-scroll {
              display: flex;
              gap: 3rem;
              /* 🎯 BEST SPEED: Slowed down to 25s for better readability and a professional look */
              animation: scroll 25s linear infinite;
              will-change: transform;
            }
            @keyframes scroll {
              0% {
                transform: translateX(0);
              }
              100% {
                /* 🎯 CRITICAL FIX: The exact pixel calculation for a perfect, seamless loop: 
         (11 logos * 200px) + (10 gaps * 48px) = -2680px
      */
                transform: translateX(-2680px);
              }
            }
          `}</style>
        </section>

        {/* <section className="bg-gray-50 py-20">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    
    <h2 className="text-3xl font-extrabold text-gray-900 mb-4 text-center">
      Our Clients
    </h2>
    <p className="text-lg text-gray-700 max-w-3xl mx-auto mb-12 text-center">
      We are proud to have collaborated with industry-leading companies worldwide.
    </p>

    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8 justify-items-center">
      
      {[
        Client1, Client2, Client3, Client4, Client5,
        Client6, Client7, Client8, Client9, Client10, 
        Client11,
      ].map((img, idx) => (
        <div 
          key={idx}
          className="w-full h-24 p-2 flex items-center justify-center bg-white rounded-lg shadow-md"
        >
          <img
            src={img}
            alt={`Client ${idx + 1}`}
            // Use object-contain to ensure the logo is fully visible within the container
            className="max-h-full max-w-full object-contain"
          />
        </div>
      ))}
      
    </div>
  </div>
</section> */}

        {/* IMPORTANT: Remove the entire <style jsx> block for the scroll animation */}
      </div>
    </>
  );
};

export default Home;
